import { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';

import { axios } from './axios';
import { Address } from '../pages/types';
import { BOTTOM_TOAST } from '../utils';

export const createAddress = (
  address: Partial<Address>
): Promise<AxiosResponse<Address> | void> => {
  return axios.post('addresses', address);
};

export const updateAddress = (
  addressId: string,
  address: Address
): Promise<AxiosResponse<Address> | void> => {
  if (!addressId) {
    toast.error('Address is invalid because it is missing an id.', BOTTOM_TOAST);
    return Promise.resolve();
  }
  return axios.put(`addresses/${addressId}`, address);
};

export const deleteAddress = (id: string): Promise<AxiosResponse | void> => {
  if (!id) {
    toast.error('Address is invalid because it is missing an id.', BOTTOM_TOAST);
    return Promise.resolve();
  }
  return axios.delete(`addresses/${id}`);
};
